import { AudioPlayer, SegmentPlayer } from "./segmentPlayer";

/**
 * 解压视频播放器
 */
export class DecompressPlayer {
  _on: any; // 绑定事件
  audio: AudioPlayer | null // 当前播放音频
  audioUrl: string
  currentTime: number // 当前播放时间

  segmentPlayer: SegmentPlayer
  constructor({ audioUrl, on, segments, canvasRef }) {
    console.log('audioTimeupdate',on)
    this._on = on
    this.audioUrl = audioUrl
    this.initAudio()
    this.segmentPlayer = new SegmentPlayer({
      segments,
      canvasRef,
      on
    })
  }

  get paused() {
    return this.audio.paused
  }
  get duration() {
    return this.audio.duration
  }
  get activeSegment() {
    return this.segmentPlayer.activeSegment
  }
  show(time) {
    this.segmentPlayer.show(time)
  }
  initCallback(loadingCallback) {
    this.segmentPlayer.initCallback(loadingCallback)
  }
  resize(canvasRef) {
    this.segmentPlayer.resize(canvasRef)
  }

  play(currPlayTime) {
    let _currPlayTime = currPlayTime
    this.segmentPlayer.play(_currPlayTime, () => {
      if (this.paused) {
        if (_currPlayTime === null) {
          if (this.audio) this.playAudio(this.audio.currentTime)
        } else {
          if (this.audio) this.playAudio(_currPlayTime)
        }
      }
      _currPlayTime = null
    })
    
  }
  updateAudioUrl(audioUrl) {
    this.audio.updateAudioUrl(audioUrl)
  }
  pause() {
    this.audio?.pause()
    this.segmentPlayer.pause()
  }
  tryPlayFirstVideo() {
    this.segmentPlayer.tryPlayFirstVideo()
  }
  checkPlay() {
    this.segmentPlayer.checkPlay()
  }
  initAudio() {
    this.audio = new AudioPlayer({
      audioUrl: this.audioUrl,
      on: {
        'error': (err) => {
          console.log('error',this.audioUrl)
        },
        'ended': () => {
          if (!this.audio) return
          // this.playerEndCallback() // 以视频结束为准，存在audio时长小于video时长/speed
        },
        'timeupdate': () => {
          if (!this.audio) return
          if (this.audio.paused) return // 音频暂停中，不继续推动
          this._on.audioTimeupdate(this.audio.currentTime)
        },
        'durationchange': () => {
          if (!this.audio) return
          this._on.durationchange()
        },
        'pause': () => {
          if (!this.audio) return
          this._on.pause()
        }
      }
    })
  }
  playAudio(time) {
    this.audio?.play(time)
  }
}